"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./MapmakerToolbar.css");
function MapmakerToolbar(_a) {
    var _b;
    var { color = "dark", children } = _a, props = __rest(_a, ["color", "children"]);
    props.className = `mapmaker-toolbar color-${color} ${(_b = props === null || props === void 0 ? void 0 : props.className) !== null && _b !== void 0 ? _b : ""}`;
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { children: children }));
}
exports.default = MapmakerToolbar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJUb29sYmFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvamVjdC9zaGFyZWQvdG9vbGJhci9NYXBtYWtlclRvb2xiYXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQ0EsaUNBQStCO0FBVS9CLFNBQXdCLGVBQWUsQ0FBQyxFQUlqQjs7UUFKaUIsRUFDdEMsS0FBSyxHQUFHLE1BQU0sRUFDZCxRQUFRLE9BRWEsRUFEbEIsS0FBSyxjQUg4QixxQkFJdkMsQ0FEUztJQUVSLEtBQUssQ0FBQyxTQUFTLEdBQUcsMEJBQTBCLEtBQUssSUFBSSxNQUFBLEtBQUssYUFBTCxLQUFLLHVCQUFMLEtBQUssQ0FBRSxTQUFTLG1DQUFJLEVBQUUsRUFBRSxDQUFDO0lBQzlFLE9BQU8sZ0RBQVMsS0FBSyxjQUFHLFFBQVEsSUFBTyxDQUFDO0FBQzFDLENBQUM7QUFQRCxrQ0FPQyJ9